import authenticated from './http-clients/authenticated'

export default {
  index(params) {
    let url = `/tenants/${params.tenantID}/media?paginate=true`

    if (typeof(params.type) !== 'undefined' && params.type !== null) {
      url = `${url}&type=${params.type}`
    }
    if (typeof(params.module) !== 'undefined' && params.module !== null) {
      url = `${url}&module=${params.module}`
    }
    if (typeof(params.order) !== 'undefined' && params.order !== null) {
      url = `${url}&order=${params.order}`
    }
    if (typeof(params.desc) !== 'undefined' && params.desc !== null) {
      url = `${url}&desc=${params.desc}`
    }
    if (typeof(params.search) !== 'undefined' && params.search !== null) {
      url = `${url}&search=${params.search}`
    }
    if (typeof(params.page) !== 'undefined' && params.page !== null) {
      url = `${url}&page=${params.page}`
    }

    return authenticated({
      url,
      method: 'get'
    })
  },
  show({ tenantID, mediaID }) {
    return authenticated({
      url: `/tenants/${tenantID}/media/${mediaID}`,
      method: 'get'
    })
  },
  store({ tenantID, data }) {
    return authenticated({
      url: `/tenants/${tenantID}/media`,
      method: 'post',
      data
    })
  },
  update({ tenantID, mediaID, data }) {
    return authenticated({
      url: `/tenants/${tenantID}/media/${mediaID}`,
      method: 'post',
      data
    })
  },
  destroy({ tenantID, mediaID }) {
    return authenticated({
      url: `/tenants/${tenantID}/media/${mediaID}`,
      method: 'delete'
    })
  },
  relateModules({ tenantID, mediaID, data }) {
    return authenticated({
      url: `/tenants/${tenantID}/media/${mediaID}/modules`,
      method: 'post',
      data
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/media.js